export default __webpack_public_path__ + "static/media/escapeartist.9ead7c2c.png";